import script from "./LayerSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./LayerSettings.vue?vue&type=script&setup=true&lang=js"

import "./LayerSettings.vue?vue&type=style&index=0&id=66f876cb&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f876cb"]])

export default __exports__